if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        this.resetMediaPosition();
        this.removeMagnifyOverlays();
        super.hide();
      }

      show(opener) {
        this.resetMediaPosition();
        this.removeMagnifyOverlays();
        super.show(opener);
        this.showActiveMedia();
      }

      removeMagnifyOverlays() {
        document.querySelectorAll('.image-magnify-full-size').forEach((overlay) => overlay.remove());
        document.querySelectorAll('.image-magnify-hover').forEach((image) => {
          image.style.opacity = '';
          image
            .closest('.product-media-container')
            ?.querySelector('.loading__spinner:not(.hidden)')
            ?.classList.add('hidden');
        });
      }

      resetMediaPosition() {
        this.querySelectorAll('[role="document"], .product-media-modal__content, .product-media-modal__content > *').forEach(
          (element) => {
            element.scrollTop = 0;
            element.scrollLeft = 0;
          }
        );
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        this.resetMediaPosition();

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
